module.exports = __webpack_public_path__ + "static/media/TurkeyScat.svg";